import { ReactElement } from 'react';

const NominationStep3AlertContent1 = (): ReactElement => (
  <div>
    <br />
    <div>
      The person who received the fine can authorise you to manage their fines if you are:
      <br /><br />
      {' '}
      * Executor of a deceased estate <br />
      * State trustee for a beneficiary <br />
      * Attorney appointed under a Power of Attorney <br />
      * Attorney appointed by a VCAT order <br />
      * Guardian appointed by a VCAT order <br />
      {' '}
      <br />
      <span>
        If you fall into one of the above categories, and therefore have legal authorisation to submit a nomination statement, please visit <a href="https://online.fines.vic.gov.au/Your-options/Find-a-form" target="_blank" rel="noreferrer">Find a form</a> to download a PDF nomination statement for completion.
      </span>
      <br />
      {' '}
    </div>
    <br />
    <p>
      If you do not have consent, the person who received the fine should complete this nomination.
    </p>
  </div>
);

export default NominationStep3AlertContent1;
